module.exports = __webpack_public_path__ + "img/wsc_p9_img_10.5817b89e.png";